

export default {
  CLEAR_CURRENT_CONFIRMATION (state) {
    state.currentConfirmation = null;
  },
  CLEAR_ATTESTATIONS (state) {
    state.attestationDetail = [];
    state.attestationHistory = [];
    state.attestations = [];
  },
  CLEAR_ATTESTATION_POLLING_HANDLE (state) {
    if(state.attestationPollingHandle !== null) {
      clearInterval(state.attestationPollingHandle);
    }
    state.attestationPollingHandle = null;
  },
  SET_ATTESTATION_DETAIL (state, attestationDetail) {
    state.attestationDetail = attestationDetail;
  },
  SET_ATTESTATION_HISTORY (state, history) {
    state.attestationHistory = history;
  },
  SET_ATTESTATION_HISTORY_DETAIL (state, detail) {
    state.attestationHistoryDetail = detail;
  },

  SET_ATTESTATIONS (state, attestations) {
    state.attestations = attestations;
  },
  SET_ATTESTATIONS_LOADING (state, attestationsLoading) {
    state.attestationsLoading = attestationsLoading;
  },
  SET_ATTESTATION_CONFIRMATIONS_PENDING (state, count) {
    state.attestationConfirmationsPending = count;
  },
  SET_ATTESTATION_REQUESTS_PENDING (state, count) {
    state.attestationRequestsPending = count;
  },
  SET_ATTESTATION_POLLING_HANDLE (state, handle) {
    state.attestationPollingHandle = handle;
  },
}
